// @ts-nocheck
import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProduct, HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSelectedImageIndex from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetSelectedImageIndex";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
/* Store Custom Code
import ProductImageCarousel, {
    ProductImageCarouselStyles,
} from "@insite/content-library/Components/ProductImageCarousel";
*/
// import ProductPrimaryImage, { ProductPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage"; // Sas
import Badge from "@insite/mobius/Badge";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { useMemo } from "react";
// import { imageStyles } from "@store/Themes/common/mixins/image"; // Sas
// import ProductImageCarousel, {
//     productImageCarouselImageWidth,
//     ProductImageCarouselStyles,
// } from "@store/Overrides/Components/ProductImageCarousel"; // Sas

/* Sas ---> */
import translate from "@insite/client-framework/Translate";
import { ProductImageCarouselStyles } from "@insite/content-library/Components/ProductImageCarousel";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import useCanScroll from "@store/Framework/Store/Bunzl/Pages/ProductDetails/Hooks/useCanScroll";
import ArrowBackward from "@store/Library/Components/Icons/ArrowBackward";
import ArrowForward from "@store/Library/Components/Icons/ArrowForward";
import ProductPrimaryImage, { ProductPrimaryImageStyles } from "@store/Overrides/Components/ProductPrimaryImage";
import { imageStyles, lazyImageStyles } from "@store/Themes/common/mixins";
import { carouselButtonStyle } from "@store/Themes/common/props/button";
/* <--- Sas */

const zoomMaxsize = 95;
const zoomCarouselSpacing = pxToRem(16);

const enum fields {
    showCarousel = "showCarousel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showCarousel]?: boolean;
    };
}

/* Store Custom Code */

type Props = OwnProps &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>; // Store Custom Code

const mapStateToProps = (state: ApplicationState, ownProps: HasProductContext) => ({
    selectedImage: getSelectedImage(state, ownProps.productContext.product),
    selectedImageIndex: state.pages.productDetails.selectedImageIndex,
});

const mapDispatchToProps = {
    setSelectedImageIndex,
};

const _zoomViewSize = 95; // Sas

export interface ProductDetailsPrimaryImageStyles {
    /**
     * @deprecated Use primaryImage styles instead.
     */
    centeringWrapper?: InjectableCss;
    hiddenWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    image?: LazyImageProps;

    primaryImage?: ProductPrimaryImageStyles;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageCarousel?: ProductImageCarouselStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    // Sas
    wrapper?: InjectableCss;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowButton?: ButtonPresentationProps;
}

export const primaryImageStyles: ProductDetailsPrimaryImageStyles = {
    fullPrimaryImageModal: {
        closeButtonIconProps: {
            css: css`
                ${x => x.theme.modal.defaultProps?.closeButtonIconProps?.css}
                top: 0 !important;
            `,
        },
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                height: auto !important;
                max-width: ${_zoomViewSize}vw !important;
                max-height: ${_zoomViewSize}vh !important;
            `,
            modalTitle: css`
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0;
                border: 0;
            `,
            modalContent: css`
                padding: 0;
                text-align: center;
            `,
        },
        closeButtonProps: {
            shape: "rectangle",
            color: undefined,
            size: undefined,
            buttonType: undefined,
            css: css`
                border: 0;
                background-color: ${getColor("common.background")};
                padding: 0.5em;
                height: auto;
                transition: none;

                &:focus {
                    outline-offset: -${({ theme }) => theme?.focus?.width};
                }
            `,
        },
    },
    fullPrimaryImage: {
        image: {
            css: css`
                display: flex;

                img {
                    display: block;
                    width: auto;
                    max-height: ${_zoomViewSize}vh;
                    max-width: ${_zoomViewSize}vw;
                }

                p {
                    padding: 1em 3em 1em 1em;
                }
            `,
        },
        loadingWrapper: {
            css: css`
                ${({ theme }) => `
                    width: ${_zoomViewSize / theme.design.product.image.large.ratio}vh;
                    max-width: ${theme.design.product.image.large.width}px;
                    max-height: ${theme.design.product.image.large.height}px;
                    padding-top: ${theme.design.product.image.large.ratio * 100}%;
                `}
            `,
        },
    },
    primaryImage: {
        image: {
            css: css`
                ${lazyImageStyles()}
            `,
        },
        centeringWrapper: {
            css: css`
                width: 100%;
                ${({ theme }) => imageStyles(theme.design.product.image.medium.ratio)}

                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: ${({ theme }) => theme.design.product.image.medium.width}px;
                            `,
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
    },
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    prevArrowButton: {
        ...carouselButtonStyle("left"),
        css: css`
            ${carouselButtonStyle("left").css}
            top: 50%;
            transform: translate(-50%, -50%);
        `,
    },
    nextArrowButton: {
        ...carouselButtonStyle("right"),
        css: css`
            ${carouselButtonStyle("right").css}
            top: 50%;
            transform: translate(50%, -50%);
        `,
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
};

const styles = primaryImageStyles;

const ProductDetailsPrimaryImage = ({
    productContext,
    selectedImage,
    selectedImageIndex,
    setSelectedImageIndex,
    // Store Custom Code
    fields: { showCarousel },
}: Props) => {
    const [fullPrimaryImageModalIsOpen, setFullImageModalIsOpen] = useState(false);
    // Sas --->
    const { canScrollNext, canScrollPrev } = useCanScroll();
    // <--- Sas
    const imageClickHandler = () => {
        setFullImageModalIsOpen(true);
    };
    const fullPrimaryImageModalCloseHandler = () => {
        setFullImageModalIsOpen(false);
    };

    const selectImageHandler = (index: number) => {
        setSelectedImageIndex({ index });
    };

    const { product } = productContext;

    /* Sas Removed Code */

    if (!product) {
        return null;
    }

    const image =
        selectedImage ??
        ({
            id: product.id,
            imageAltText: product.imageAltText,
            imageType: "Static",
            largeImagePath: product.largeImagePath,
            mediumImagePath: product.mediumImagePath,
            smallImagePath: product.smallImagePath,
        } as ImageModel);

    const path = image.mediumImagePath || image.largeImagePath;
    /* Sas ---> */
    const customImageProps: any = {};
    if (!path) {
        customImageProps.onClick = null;
    } else {
        customImageProps.extendedStyles = {
            ...styles.primaryImage,
            image: {
                css: css`
                    ${styles.primaryImage?.image?.css}
                    cursor: zoom-in;
                `,
            },
        };
    }

    const scrollNext = () => {
        const scrollNextEvent = new Event("click:primaryImageScrollNext");
        document.dispatchEvent(scrollNextEvent);
    };
    const scrollPrev = () => {
        const scrollPrevEvent = new Event("click:primaryImageScrollPrev");
        document.dispatchEvent(scrollPrevEvent);
    };
    /* <--- Sas */

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Sas ---> */}
            {canScrollPrev && (product.images as ImageModel[])?.length > 0 && (
                <Button {...styles.prevArrowButton} onClick={scrollPrev} data-test-selector="prevBtn">
                    <ButtonIcon src={ArrowBackward} />
                    <VisuallyHidden>{translate("Previous Slide")}</VisuallyHidden>
                </Button>
            )}
            {/* <--- Sas */}
            <ProductPrimaryImage
                product={product}
                image={image}
                onClick={imageClickHandler}
                extendedStyles={styles.primaryImage}
                {...customImageProps} // Sas
            />
            {/* Sas ---> */}
            {canScrollNext && (product.images as ImageModel[])?.length > 0 && (
                <Button
                    {...styles.nextArrowButton}
                    onClick={scrollNext}
                    disabled={!canScrollNext}
                    data-test-selector="nextBtn"
                >
                    <ButtonIcon src={ArrowForward} />
                    <VisuallyHidden>{translate("Next Slide")}</VisuallyHidden>
                </Button>
            )}
            {/* <--- Sas */}
            <Modal
                {...styles.fullPrimaryImageModal}
                isOpen={fullPrimaryImageModalIsOpen}
                handleClose={fullPrimaryImageModalCloseHandler}
            >
                <ProductPrimaryImage
                    product={product}
                    image={image}
                    useLargeImage={true}
                    extendedStyles={styles.fullPrimaryImage}
                    showLoader={true} // Sas
                />
                {/* SasRemoved Carousel */}
            </Modal>
            {/* </> */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPrimaryImage)),
    definition: {
        displayName: "Primary Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
